function paramsToSaleURL(params) {
    //generates a URL which will take you to a list of sales matching the passed params
    //store can be missed out entirely to hit the different route
    var url = "/sales" + (params.storeID === undefined ? "" : "/" + params.storeID) + "/params/" + btoa(JSON.stringify(params))
    //console.log("Calculated sales url: " + url + " from params " + JSON.stringify(params))
    return url
}

export {paramsToSaleURL}